import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, BrainIcon, HeartIcon, DollarSignIcon } from 'lucide-react';
const failedMethods = [{
  method: 'Apps de presupuesto',
  reason: 'Tratan el síntoma, no la causa'
}, {
  method: 'Cursos de finanzas',
  reason: 'Dan información al 5% consciente, ignoran el 95% subconsciente'
}, {
  method: 'Motivación y libros de autoayuda',
  reason: 'El efecto dura 48-72 horas máximo'
}, {
  method: 'Afirmaciones genéricas',
  reason: 'Tu mente las rechaza como falsas'
}, {
  method: 'Fuerza de voluntad',
  reason: 'Se agota. No es sostenible'
}];
const solutions = [{
  level: 'Mental',
  icon: <BrainIcon className="w-6 h-6 text-gold" data-id="element-51" />,
  what: 'Las creencias y pensamientos dominantes',
  how: 'Método Rompe & Reemplaza con base en neurociencia'
}, {
  level: 'Espiritual',
  icon: <HeartIcon className="w-6 h-6 text-gold" data-id="element-52" />,
  what: 'La alineación con tu propósito y fe',
  how: 'Sistema Neuro-Espiritual de Visualización con Propósito'
}, {
  level: 'Práctico',
  icon: <DollarSignIcon className="w-6 h-6 text-gold" data-id="element-53" />,
  what: 'La arquitectura financiera real',
  how: 'Fórmula 70/30 + Plan de acción a 365 días'
}];
export function FailedMethodsSection() {
  return <section className="py-12 md:py-16 px-4 md:px-8 bg-navy-midnight" data-id="element-54">
      <div className="max-w-5xl mx-auto" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="mb-16 text-center" data-id="element-56">
          <h3 className="text-3xl md:text-5xl font-headline font-extrabold text-white mb-12" data-id="element-57">
            El Error Que Cometen Todos Los Otros Métodos
          </h3>

          <div className="grid grid-cols-1 gap-4 max-w-3xl mx-auto mb-16" data-id="element-58">
            {failedMethods.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-navy-dark border border-gold-separator/20 rounded-xl p-6 flex flex-col md:flex-row md:items-center gap-4 text-left shadow-soft" data-id="element-59">
                <div className="md:w-1/2 font-headline font-bold text-white flex items-center gap-3" data-id="element-60">
                  <XCircleIcon className="w-5 h-5 text-orange flex-shrink-0" data-id="element-61" />
                  {item.method}
                </div>
                <div className="md:w-1/2 text-body font-body" data-id="element-62">
                  {item.reason}
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-navy-dark border-l-4 border-gold p-8 md:p-12 mb-20 rounded-r-2xl shadow-gold" data-id="element-63">
          <h4 className="text-xl text-gold-light font-headline font-bold mb-6" data-id="element-64">
            La razón real por la que nada funcionó:
          </h4>
          <blockquote className="text-2xl md:text-3xl font-serif text-white italic leading-relaxed" data-id="element-65">
            "Todos intentaron cambiar tus acciones. Ninguno cambió el programa
            que genera esas acciones."
          </blockquote>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-66">
          <h3 className="text-2xl md:text-4xl font-headline font-extrabold text-white mb-10 text-center" data-id="element-67">
            La Solución Que Trabaja Los 3 Niveles Reales Del Problema:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-68">
            {solutions.map((sol, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="bg-navy-dark border-t-4 border-gold rounded-b-xl p-8 flex flex-col h-full hover:bg-navy-dark/80 transition-colors shadow-soft" data-id="element-69">
                <div className="flex items-center gap-3 mb-6" data-id="element-70">
                  <div className="p-3 bg-navy-midnight rounded-lg" data-id="element-71">
                    {sol.icon}
                  </div>
                  <h4 className="text-2xl font-headline font-bold text-white" data-id="element-72">
                    {sol.level}
                  </h4>
                </div>

                <div className="space-y-4 flex-grow" data-id="element-73">
                  <div data-id="element-74">
                    <span className="text-xs text-gold-separator uppercase font-headline font-bold tracking-wider" data-id="element-75">
                      Qué Es
                    </span>
                    <p className="text-body font-body mt-1" data-id="element-76">{sol.what}</p>
                  </div>
                  <div data-id="element-77">
                    <span className="text-xs text-gold uppercase font-headline font-bold tracking-wider" data-id="element-78">
                      Cómo Lo Resuelve
                    </span>
                    <p className="text-white font-headline font-semibold mt-1" data-id="element-79">
                      {sol.how}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>

          <p className="text-center text-xl md:text-2xl font-serif text-gold-light italic" data-id="element-80">
            No es un libro de tips. Es un sistema de reprogramación completa.
          </p>
        </motion.div>
      </div>
    </section>;
}